import { Injectable } from '@angular/core';
import * as _ from 'underscore';

@Injectable()
export class PaginationService {

	constructor() { }

	getPager(totalItems: number, currentPage: number = 1, pageSize: number = 10) {
		var totalPages = Math.ceil(totalItems / pageSize);

		currentPage = Math.min(totalPages, Math.max(1, currentPage));

		var startPage: number, endPage: number;

		if (totalPages <= 10) {
			startPage = 1;
			endPage = totalPages;
		} else {
			if (currentPage <= 6) {
				startPage = 1;
				endPage = 10;
			} else if (currentPage + 4 >= totalPages) {
				startPage = totalPages - 9;
				endPage = totalPages;
			} else {
				startPage = currentPage - 5;
				endPage = currentPage + 4;
			}
		}

		var startIndex = (currentPage - 1) * pageSize;
		var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

		var pages = _.range(startPage, endPage + 1);

		return {
			totalItems: totalItems,
			currentPage: currentPage,
			pageSize: pageSize,
			totalPages: totalPages,
			startPage: startPage,
			endPage: endPage,
			startIndex: startIndex,
			endIndex: endIndex,
			pages: pages
		};
	}

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/services/pagination.service.ts